module.exports = __webpack_public_path__ + "img/uJETB0x3LrbWOg1lRXU69Tlxg1IQUFFX.bdf00832.png";